import React, { useEffect, useMemo, useState } from 'react';
import {
  mdiHexagonMultipleOutline, mdiTableSearch, mdiTextBoxSearchOutline,
} from '@mdi/js';
import { Tabs } from 'antd';
import { UI54Card } from '@agpl/ui54kit';
import BaseIcon from '../../_ui/BaseIcon/BaseIcon';
import { capitalizeAndTranslateMsg } from '../../mainUtils';
import ActorsPage from './ActorsPage';
import LogsPage from '../../logsView/components/LogsPage';
import GroupsPriorityPage from '../../groups/components/GroupsPriorityPage';

function ActorsAndPerms() {
  const [activeKey, setActiveKey] = useState('actorssearch');

  const getLabelAndTranslate = (label, iconPath, translatePath = '') => (
    <span>
      <BaseIcon path={iconPath} size={1} />
      <span className="ml-1">{capitalizeAndTranslateMsg(translatePath, label)}</span>
    </span>
  );

  const onTabClick = (key) => {
    setActiveKey(key);
  };

  const items = useMemo(() => (
    [
      {
        label: getLabelAndTranslate('Actors search', mdiTableSearch, 'auth.messages.actors_search'),
        key: 'actorssearch',
        children: <ActorsPage />,
      },
      {
        label: getLabelAndTranslate('Actors logs', mdiTextBoxSearchOutline, '54origins.noun.actors_logs'),
        key: 'actorslogs',
        children: <LogsPage />,
      },
      {
        label: getLabelAndTranslate('Groups priority', mdiHexagonMultipleOutline, 'auth.messages.groups_priority'),
        key: 'groupspriority',
        children: <GroupsPriorityPage />,
      },
    ]
  ), []);

  return (
    <UI54Card>
      <Tabs
        onTabClick={onTabClick}
        defaultActiveKey="actorssearch"
        activeKey={activeKey}
        destroyInactiveTabPane
        items={items}
      />
    </UI54Card>
  );
}

export default ActorsAndPerms;
